import React, { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import { storeService } from '../services/store.service';

interface SEOContextType {
  companyName: string;
  companyLogo: string;
}

const SEOContext = createContext<SEOContextType | undefined>(undefined);

interface SEOProviderProps {
  children: ReactNode;
  companyName?: string;
  companyLogo?: string;
}

export const SEOProvider: React.FC<SEOProviderProps> = ({
  children,
  companyName: propCompanyName,
  companyLogo: propCompanyLogo,
}) => {
  const [companyName, setCompanyName] = useState(propCompanyName || '');
  const [companyLogo, setCompanyLogo] = useState(propCompanyLogo || '');

  useEffect(() => {
    if (!propCompanyName) {
      const cachedName = storeService.getCompanyName();
      if (cachedName) setCompanyName(cachedName);
    }
    if (!propCompanyLogo) {
      const cachedLogo = storeService.getCompanyLogoUrl();
      if (cachedLogo) setCompanyLogo(cachedLogo);
    }
  }, [propCompanyName, propCompanyLogo]);

  return (
    <SEOContext.Provider value={{ companyName, companyLogo }}>
      {children}
    </SEOContext.Provider>
  );
};

export const useSEO = (): SEOContextType => {
  const context = useContext(SEOContext);
  if (context) {
    return context;
  }

  // Fallback: get from storeService cache if no provider
  const companyName = storeService.getCompanyName() || '';
  const companyLogo = storeService.getCompanyLogoUrl() || '';

  return { companyName, companyLogo };
};

export default SEOContext;
